import * as React from 'react'

const GearIcon = (props: any) => {
  return (
    <svg
      {...props}
      className={'icon ' + props.className}
      width='13'
      height='13'
      viewBox='0 0 13 13'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M11.1445 7.1125C11.1695 6.9125 11.1883 6.7125 11.1883 6.5C11.1883 6.2875 11.1695 6.0875 11.1445 5.8875L12.4633 4.85625C12.582 4.7625 12.6133 4.59375 12.5383 4.45625L11.2883 2.29375C11.2133 2.15625 11.0445 2.10625 10.907 2.15625L9.35075 2.78125C9.02575 2.53125 8.67575 2.325 8.2945 2.16875L8.057 0.5125C8.03825 0.3625 7.907 0.25 7.75075 0.25H5.25075C5.0945 0.25 4.96325 0.3625 4.9445 0.5125L4.707 2.16875C4.32575 2.325 3.97575 2.5375 3.65075 2.78125L2.0945 2.15625C1.95075 2.1 1.78825 2.15625 1.71325 2.29375L0.463254 4.45625C0.382004 4.59375 0.419504 4.7625 0.538254 4.85625L1.857 5.8875C1.832 6.0875 1.81325 6.29375 1.81325 6.5C1.81325 6.70625 1.832 6.9125 1.857 7.1125L0.538254 8.14375C0.419504 8.2375 0.388254 8.40625 0.463254 8.54375L1.71325 10.7062C1.78825 10.8438 1.957 10.8938 2.0945 10.8438L3.65075 10.2188C3.97575 10.4688 4.32575 10.675 4.707 10.8313L4.9445 12.4875C4.96325 12.6375 5.0945 12.75 5.25075 12.75H7.75075C7.907 12.75 8.03825 12.6375 8.057 12.4875L8.2945 10.8313C8.67575 10.675 9.02575 10.4625 9.35075 10.2188L10.907 10.8438C11.0508 10.9 11.2133 10.8438 11.2883 10.7062L12.5383 8.54375C12.6133 8.40625 12.582 8.2375 12.4633 8.14375L11.1445 7.1125ZM6.50075 8.6875C5.2945 8.6875 4.31325 7.70625 4.31325 6.5C4.31325 5.29375 5.2945 4.3125 6.50075 4.3125C7.707 4.3125 8.68825 5.29375 8.68825 6.5C8.68825 7.70625 7.707 8.6875 6.50075 8.6875Z'
        fill='#37C47E'
      />
    </svg>
  )
}

export default GearIcon



// WEBPACK FOOTER //
// ./src/components/icons/ui/GearIcon.tsx